import { fetcherV3 } from 'repositories/ApiV3/apiClientV3'

import { berthAssignmentConditionsEndpoint } from './endpoint'
import type { CheckConditionUsageParams, CheckConditionUsageResponse } from './type'

/**
 * 受付カスタマイズ項目が自動バース割当条件で使用中かを確認する（TB-1953）。
 *
 * 呼び出し側はアラート表示の要否だけを必要とするため `used` の真偽値のみを返す。
 */
export const checkConditionUsage = async (params: CheckConditionUsageParams): Promise<boolean> => {
  const res = await fetcherV3<CheckConditionUsageResponse>(
    berthAssignmentConditionsEndpoint.usage(params.tenantId),
    { params: { columnName: params.columnName } }
  )
  return res.used
}
